import FormTemplateList from '@/components/admin/formtemplate/FormTemplateList'
import FormTemplate from '@/components/admin/formtemplate/FormTemplate'
import FormTemplateEditor from '@/components/admin/formtemplate/editor/FormTemplate'
import auth from './../auth'

export default [
  {
    path: '/admin/forms/',
    name: 'FormTemplateList',
    component: FormTemplateList,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/form/:id?',
    name: 'FormTemplateLegacy',
    component: FormTemplate,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/forms/editor/:id?',
    name: 'FormTemplate',
    component: FormTemplateEditor,
    beforeEnter: auth.ifAuthenticated,
    meta: { fullWidth: true }
  }
]
